import { queryString } from '@cinch/oxd-utils/requests/src'

const getUrlParameter = (name: string, locationSearch: string): string => {
  name = name.replace(/[[]/, '\\[').replace(/[\]]/, '\\]')
  const regex = new RegExp(`[?&]${name}=([^&#]*)`)
  const results = regex.exec(locationSearch)

  return results ? decodeURIComponent(results[1].replace(/\+/g, ' ')) : ''
}

// TODO get some tests done for this
export const getParam = (search: string) => (param: string): string => {
  if (typeof window === 'undefined') {
    return ''
  }

  if (typeof URLSearchParams === 'undefined') {
    return getUrlParameter(param, search)
  } else {
    const urlParams = new URLSearchParams(search)

    return urlParams.get(param) || getUrlParameter(param, search)
  }
}

export const getAllUrlParams = () => {
  if (typeof window === 'undefined') {
    return ''
  }

  return window.location.search.length > 1
    ? window.location.search
        .substring(1)
        .split('&')
        .map((urlParamPair) => urlParamPair.split('='))
        .reduce(
          (accum, [key, val]) => ({
            ...accum,
            [key]: val,
          }),
          {} as { [key: string]: any },
        )
    : {}
}

export const removeMarketingParamsFromUrl = (searchStr: string) => {
  if (typeof window === 'undefined') {
    return ''
  }

  const tmp =
    searchStr.length > 1
      ? searchStr
          .split('?')[1]
          .split('&')
          .map((urlParamPair) => urlParamPair.split('='))
          .reduce(
            (accum, [key, val]) => ({
              ...accum,
              [key]: val,
            }),
            {} as { [key: string]: any },
          )
      : {}

  delete tmp.cid
  delete tmp.icid

  return `${searchStr.split('?')[0]}?${queryString(tmp)}`
}
